import React, { useCallback, useState } from 'react';
import { Formik } from 'formik';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormLayout } from './form-layout';
import { VALIDATION_SCHEMA } from './validation-schema';
import { INITIAL_VALUES } from './initial-values';
import { submitRequest } from './submit-request';

export function Form() {
  const [step, setStep] = useState(0);
  const { t, i18n } = useTranslation();

  const handleSubmit = useCallback(async (values) => {
    try {
      await submitRequest(values);
      setStep(2);
    } catch (error) {
      notification.error({
        message: t('submit.failed'),
        description: t('submit.failed-message'),
      });
    }
  }, [i18n.language]);

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      validationSchema={VALIDATION_SCHEMA}
      onSubmit={handleSubmit}
    >
      <FormLayout
        setStep={setStep}
        step={step}
      />
    </Formik>
  );
}
